import { useMemo } from 'react'
import { MediaInfo } from '../../../types'

const useStripFrameCount = (mediaInfo: MediaInfo, width: number, height: number): number => {
    const numFrames = useMemo(() => {
        if (!mediaInfo.width) return 0

        const aspectRatio = mediaInfo.width / mediaInfo.height
        const frameWidth = Math.round(height * aspectRatio)

        return Math.ceil(width / frameWidth)
    }, [mediaInfo.width, height, width])

    return numFrames
}

export default useStripFrameCount
